import React from 'react';
import ReactDOM from 'react-dom';
import './css/flaticon.css';
import './css/font-awesome.min.css';
import './css/themify-icons.css';
import './index.css';
import App from './main-component/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
